import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/how-it-works', label: 'How It Works' },
    { path: '/calculator', label: 'Calculator' },
    { path: '/case-studies', label: 'Case Studies' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <header className="navbar">
      <div className="nav-container">
        <Link to="/" className="logo" style={{ 
          display: 'flex', 
          alignItems: 'center', 
          textDecoration: 'none',
          gap: 0
        }}>
          <span style={{ 
            color: '#000000', 
            fontWeight: 'bold', 
            fontSize: '24px',
            fontFamily: 'sans-serif'
          }}>
            The
          </span>
          <span style={{
            backgroundColor: 'var(--primary-green)',
            color: '#FFFFFF',
            fontWeight: 'bold',
            fontSize: '22px',
            padding: '1px 7px',
            borderRadius: '8px',
            fontFamily: 'sans-serif',
            display: 'inline-block',
            marginLeft: '5px'
          }}>
            Code Icon
          </span>
        </Link>
        <nav>
          <ul className="nav-links">
            {navItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={location.pathname === item.path ? 'text-green' : ''}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
